import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { withFormik } from "formik"; 
import { withNamespaces, Trans } from "react-i18next";

import AtiCorePopup from "ati-ui-react/components/Popup"; 

import styles from "./LegendPopup.scss";

const LegendPopup = props => {
  const { 
    closePopup,
    t,
  } = props;
  
  return (
    <AtiCorePopup
      className={styles.popupMin_480}
      onClose={closePopup}
      title={t("trace-filters-show-legend-button-text", "Легенда")}
    >
      <div className={styles.container}>
        <div className={styles.delays}>
          <span className={styles.title}>
            <Trans i18nKey="trace-legend-popup-delays-block-title">
              Размер населенного пункта
            </Trans>
          </span>
          <div className={styles.list}>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.citySize6)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-population-over-1000000">свыше 1 000 000 чел.</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.citySize5)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-population-500000-to-1000000">
                    500 000—1 000 000 чел.
                  </Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.citySize4)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-population-100000-to-500000">
                    100 000—500 000 чел.
                  </Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.citySize3)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-population-50000-to-100000">50 000—100 000 чел.</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.citySize2)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-population-10000-to-50000">10 000—50 000 чел.</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.citySize1)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-population-up-to-10000">до 10 000 чел.</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.customs)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-customs">пограничный переход</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.unloading)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-legend-popup-delays-loading-unloading">погрузка/разгрузка</Trans>
                </span> 
            </div>
          </div>
        </div>
        <div className={styles.speeds}>
          <span className={styles.title}>
            <Trans i18nKey="trace-legend-popup-speeds-block-title">Типы дорог</Trans>
          </span>
          <div className={styles.list}>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.roadTypeMotorwayIcon)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-common-road-type-motorway">автомагистраль</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.roadTypeTrunkIcon)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-common-road-type-trunk">магистраль</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.roadTypeMainIcon)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-common-road-type-common">Общего пользования</Trans>
                </span> 
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.roadTypeOtherIcon)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-common-road-type-other">другой тип</Trans>
                </span> 
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.roadTypeWinterRoadIcon)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-common-road-type-winter-road">зимник</Trans>
                </span>
            </div>
            <div className={styles.item}>
              <div className={classnames(styles.icon, styles.roadTypeFerryIcon)} />
                <span className={styles.description}>
                  <Trans i18nKey="trace-common-road-type-ferry">паромная переправа</Trans>
                </span>
            </div>
          </div>
        </div>
        <div className={styles.lineBreak} /> 
      </div> 
    </AtiCorePopup>
  );
};

LegendPopup.propTypes = {  
  closePopup: PropTypes.func.isRequired,  
  t: PropTypes.func.isRequired,
};

const LegendPopupWrapper = withFormik({
  mapPropsToValues: props => ({ 
  })
})(LegendPopup);

export default withNamespaces()(LegendPopupWrapper);
